module.exports = __webpack_public_path__ + "static/media/gear-icon-white.d38cfb03.svg";